import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({
  width, height, dPath, title, fill, ...rest
}) => (
  <svg
    viewBox="0 0 24 24"
    width={width}
    height={height}
    {...rest}
  >
    <title>{title}</title>
    <path d={dPath} fill={fill} />
  </svg>
);

const IconWithDefaults = ({
  width, height, dPath, title, fill, ...rest
}) => (
  <Icon
    dPath={dPath}
    title={title}
    width={width}
    height={height}
    fill={fill}
    focusable="false"
    aria-hidden="true"
    tabIndex="-1"
    data-ga-event-category="material-icons"
    data-ga-event-label={title}
    {...rest}
  />
);

const defaultProps = {
  width: 24,
  height: 24,
  fill: undefined,
};

const propTypes = {
  /** Sets the width */
  width: PropTypes.number,
  /** Sets the height */
  height: PropTypes.number,
  /** Sets the visible text for icon */
  title: PropTypes.string.isRequired,
  /** Sets the svg path */
  dPath: PropTypes.string.isRequired,
  /** Sets the icon fill color */
  fill: PropTypes.string,
};

Icon.defaultProps = defaultProps;
Icon.propTypes = propTypes;
IconWithDefaults.defaultProps = defaultProps;
IconWithDefaults.propTypes = propTypes;

export {
  Icon as default,
  IconWithDefaults,
};
